import { Link } from 'react-router-dom'
import { REPAIR_TASKS } from '../../data/repairTasks'

export function RepairTaskListView() {
  return (
    <div className="page page--repair-list">
      <header className="repair-list-header">
        <Link to="/hardware" className="btn-back" aria-label="Back to hardware store">←</Link>
        <h1 className="page-title">🔧 What do you want to fix?</h1>
      </header>
      <p className="repair-list-intro">
        Tap a repair. Follow the steps – you can do it in real life with a grown-up!
      </p>
      <ul className="repair-list-grid" aria-label="Repair tasks">
        {REPAIR_TASKS.map((task) => (
          <li key={task.id}>
            <Link
              to={`/hardware/repair/${task.id}`}
              className="repair-list-card"
              aria-label={`Repair: ${task.name}`}
            >
              <span className="repair-list-card-emoji" aria-hidden>{task.emoji}</span>
              <span className="repair-list-card-name">{task.name}</span>
              {task.description && (
                <span className="repair-list-card-desc">{task.description}</span>
              )}
              <span className="repair-list-card-steps">{task.steps.length} steps</span>
            </Link>
          </li>
        ))}
      </ul>
      <Link to="/hardware" className="btn-large btn-secondary" style={{ textDecoration: 'none', marginTop: 24 }}>
        Back to Hardware Store
      </Link>
    </div>
  )
}
